import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultShowtimePickerAssets, showtimePickerAssetsValidator } from '../../../subcomponents/showtime-picker/types/assets';
import { defaultShowtimePickerCdnOptions, showtimePickerCdnOptionsValidator } from '../../../subcomponents/showtime-picker/types/cdn-options';
import { defaultShowtimePickerConfig, showtimePickerConfigValidator } from '../../../subcomponents/showtime-picker/types/config';
import { defaultShowtimePickerDisplayText, showtimePickerDisplayTextValidator } from '../../../subcomponents/showtime-picker/types/display-text';
import { showtimePickerEventsValidator } from '../../../subcomponents/showtime-picker/types/events';
export const eventShowtimePickerPropsValidator = Validator.object({
    eventId: nonEmptyStringValidator,
    filmIds: Validator.optional(Validator.array({ items: nonEmptyStringValidator })),
    siteId: nonEmptyStringValidator,
    config: showtimePickerConfigValidator,
    displayText: showtimePickerDisplayTextValidator,
    events: showtimePickerEventsValidator,
    assets: showtimePickerAssetsValidator,
    cdnOptions: showtimePickerCdnOptionsValidator
});
export const defaultEventShowtimePickerProps = {
    eventId: undefined,
    siteId: undefined,
    config: defaultShowtimePickerConfig,
    displayText: defaultShowtimePickerDisplayText,
    assets: defaultShowtimePickerAssets,
    cdnOptions: defaultShowtimePickerCdnOptions,
    events: {}
};
